<template>   
    <div v-if="mode == 'form'" class="tag-item" :class="{'isForm': mode == 'form'}">
        {{value2}}
        <div class="btn remove-btn" v-if="canRemove" @click="$emit('remove', value)">
            <i class="el-icon-error"></i>
        </div>
    </div>
    <div v-else>
        <span v-if="disabled && printMode" class='showText'>{{value2}}</span>
        <el-input v-else :size="size" :value="value2" readonly="readonly" suffix-icon="fa fa-sitemap" ></el-input>    
    </div>
</template>
<script>
export default {
    name:'l-company',
    props: {
        value:String,
        size:{
            type:String,
            default:'mini'
        },
        printMode: {
            default: false
        },
        mode: {
            default: ''
        },
        canRemove: {
            default: false
        }
    },
    watch: {
         value:{
            handler(newVal){
                if(this.$validatenull(newVal) && this.loginInfo){
                    this.value2 = this.loginInfo.f_CompanyId
                }
            },
            immediate: true
        }
    },
    computed:{
        value2:{
            get(){
                if(this.$validatenull(this.value)){
                    return ''
                }
                if(this.lr_companyList){
                    return (this.lr_companyList.find(t=>t.f_CompanyId == this.value) || {} ).f_FullName || ''
                }
                else{
                    return ''
                }
            },
            set(val){
                this.$emit('input',val)
            }
        }
    },
    created(){
        this.lr_loadCompanys && this.lr_loadCompanys()
    },
}
</script>
<style scoped lang="less">
.tag-item {
        display: inline-flex;
        position: relative;
        align-items: center;
        height: 24px;
        box-sizing: border-box;
        border-radius: 14px;
        overflow: hidden;
        margin-right: 4px;
        width: auto;
        vertical-align: middle;
        overflow: visible;
        &:hover {
            .remove-btn {
                display: inline-block;
            }
        }
        &.isForm {
            background: #f5f7f9;
            height: 28px !important;
            padding: 0 12px;
            margin: 4px 0;
            margin-right: 8px;
            // color: #333;
        }
    }
    .remove-btn {
        display: none;
        position: absolute;
        top: -20px;
        right: -13px;
        font-size: 16px;
        &:hover {
            color: #F56C6C;
        }
    }
</style>